import React, { useState, useEffect } from "react";
import companyLogo from "../../assets/images/sansaar-logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import Typography from '@mui/material/Typography';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import SignInModal from "../SignInModal";
import CartDrawer from "../CartDrawer";
import CouponBand from "../CouponBand";
import { resetPreSelectedFilters } from "@common/utils/utils";
import CloudinaryAdvancedImage from "@common/utils/CloudinaryAdvancedImage";

let portrait = window.matchMedia("(orientation: portrait)");

function Header({ isBand }) {
  const [menuActive, setMenuActive] = useState(false);

  const menuActiveHandleChange = () => {
    if (menuActive) {
      setMenuActive(false);
    } else {
      setMenuActive(true);
    }
  };

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [subMenuShow, setSubMenuShow] = useState("");

  const subMenuShowHandleChange = (target) => {
    setSubMenuShow(target);
  };

  const subMenuHideHandleChange = () => {
    // alert('sub menu hide')
    setSubMenuShow(false);
  };

  const navigate = useNavigate();
  const location = useLocation();

  const handleMenuClick = (path) => {
    const lowerCasePath = path.toLowerCase();
    if (location.pathname === path.split("?")[0]) {
      // Force re-render by pushing the same path
      navigate("/");
      setTimeout(() => {
        navigate(lowerCasePath);
      }, 0);
    } else {
      navigate(lowerCasePath);
    }
    if (window.innerWidth <= 1024) {
      setMenuActive(false);
      setSubMenuShow(false);
    }
  };

  const handleMenuClickShop = (path) => {
    const lowerCasePath = path.toLowerCase();
    if (lowerCasePath.includes("/products")) {
      // navigate("/collections/all-bedding");
      window.location.href = "https://shop.sansaar.co.in/collections/all-bedding";
    } else {
      if (location.pathname === path.split("?")[0]) {
        // Force re-render by pushing the same path
        navigate("/");
        setTimeout(() => {
          navigate(lowerCasePath);
        }, 0);
      } else {
        navigate(lowerCasePath);
      }
      if (!location.pathname.includes("/shop")) {
        setMenuActive(false);
        setSubMenuShow(false);
      }
    }

  };





  return (
    <>
      <header
        className={`bs-header ${isBand ? "bs-header--typ-band" : ""} ${location.pathname.includes("reset-password")
          ? "bs-header--typ-private"
          : ""
          }`}
      >
        {isBand ? (
          <CouponBand text="Use the code <b>FESTIV10</b> and get 10% OFF" />
        ) : null}
        <div className="bs-header__main-wrap">
          <div className="bs-header__logo-wrap">
            <Link to="/" className="bs-header__logo">
              <img
                width="100%"
                height="100%"
                src={companyLogo}
                alt="Company logo"
              />
            </Link>
          </div>
          {!location.pathname.includes("reset-password") ? (
            <>
              <div
                className={`bs-header__menu-wrap ${menuActive ? "bs-header__menu-wrap--active" : ""
                  }`}
              >
                <nav className="bs-menu bs-header__menu">
                  <ul className="bs-menu__nav-list">
                    <li
                      className={`bs-menu__nav-item bs-menu__nav-item--fabric-collections ${subMenuShow === "aboutSansaar"
                        ? "bs-menu__nav-item--active"
                        : ""
                        }`}
                    >
                      {window.innerWidth <= 1024 ? (
                        <p
                          onClick={() =>
                            subMenuShowHandleChange("aboutSansaar")
                          }
                          className={`bs-menu__nav-link bs-menu__nav-link--mb ${location.pathname.includes("our-journey") ||
                            location.pathname.includes("quality-standards")
                            ? "bs-menu__nav-link--active"
                            : ""
                            }`}
                        >
                          About Sansaar{" "}
                          <span className="icon icon-down bs-menu__icon-more"></span>
                        </p>
                      ) : (
                        // <Link to="/collections" onClick={menuActiveHandleChange} className={`bs-menu__nav-link ${location.pathname.includes('collections') || location.pathname.includes('collection-detail') || location.pathname.includes('sku-detail') ? 'bs-menu__nav-link--active' : ''}`}>collections</Link>
                        <button
                          onClick={() => {
                            handleMenuClick("/our-journey");
                            menuActiveHandleChange();
                          }}
                          className={`bs-menu__nav-link ${location.pathname.includes("our-journey") ||
                            location.pathname.includes("inspired-living") ||
                            location.pathname.includes("quality-standards")
                            ? "bs-menu__nav-link--active"
                            : ""
                            }`}
                        >
                          About Sansaar
                        </button>
                      )}

                      <div className="bs-sub-menu bs-menu__sub-menu">
                        <div className="bs-sub-menu__head">
                          <button
                            className="bs-sub-menu__back-button"
                            onClick={subMenuHideHandleChange}
                          >
                            <span className="icon icon-back bs-sub-menu__icon-back"></span>
                          </button>
                          <h3 className="bs-sub-menu__head-title">
                            collections
                          </h3>
                        </div>
                        <div className="bs-sub-menu__cont">
                          <div className="bs-link-list">
                            <ul className="bs-link-list__list-wrap">
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(`/our-journey`)
                                  }
                                  className="bs-link-list__link bs-link-list__title"
                                >
                                  our journey
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="bs-link-list">
                            <ul className="bs-link-list__list-wrap">
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(`/quality-standards`)
                                  }
                                  className="bs-link-list__link bs-link-list__title"
                                >
                                  quality standards
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="bs-link-list">
                            <ul className="bs-link-list__list-wrap">
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(
                                      "/inspired-living?type=film"
                                    )
                                  }
                                  className="bs-link-list__link bs-link-list__title"
                                >
                                  inspired living
                                </button>
                              </li>
                            </ul>
                          </div>
                          {/* <div className="bs-link-list">
                            <ul className="bs-link-list__list-wrap">
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(
                                      "/sustainability"
                                    )
                                  }
                                  className="bs-link-list__link bs-link-list__title"
                                >
                                  sustainability
                                </button>
                              </li>
                            </ul>
                          </div> */}
                          <div className="bs-link-list">
                            <ul className="bs-link-list__list-wrap">
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(
                                      "/csr"
                                    )
                                  }
                                  className="bs-link-list__link bs-link-list__title"
                                >
                                  CSR Initiatives
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>
                    {/* <li className='bs-menu__nav-item bs-menu__nav-item--our-journey'>
                    <Link to="/our-journey" onClick={menuActiveHandleChange} className={`bs-menu__nav-link ${location.pathname.includes('our-journey') ? 'bs-menu__nav-link--active' : ''}`}>our journey</Link>
                  </li> */}
                    <li
                      className={`bs-menu__nav-item bs-menu__nav-item--fabric-collections ${subMenuShow === "collections"
                        ? "bs-menu__nav-item--active"
                        : ""
                        }`}
                    >
                      {window.innerWidth <= 1024 ? (
                        <p
                          onClick={() => subMenuShowHandleChange("collections")}
                          className={`bs-menu__nav-link bs-menu__nav-link--mb ${location.pathname.includes("collections") ||
                            location.pathname.includes("collection-detail") ||
                            location.pathname.includes("sku-detail")
                            ? "bs-menu__nav-link--active"
                            : ""
                            }`}
                        >
                          discover fabrics
                          <span className="icon icon-down bs-menu__icon-more"></span>
                        </p>
                      ) : (
                        // <Link to="/collections" onClick={menuActiveHandleChange} className={`bs-menu__nav-link ${location.pathname.includes('collections') || location.pathname.includes('collection-detail') || location.pathname.includes('sku-detail') ? 'bs-menu__nav-link--active' : ''}`}>collections</Link>
                        <button
                          onClick={() => {
                            handleMenuClick("/collections");
                            menuActiveHandleChange();
                          }}
                          className={`bs-menu__nav-link ${location.pathname.includes("collections") ||
                            location.pathname.includes("collection-detail") ||
                            location.pathname.includes("sku-detail")
                            ? "bs-menu__nav-link--active"
                            : ""
                            }`}
                        >
                          discover fabrics
                        </button>
                      )}

                      <div className="bs-sub-menu bs-menu__sub-menu">
                        <div className="bs-sub-menu__head">
                          <button
                            className="bs-sub-menu__back-button"
                            onClick={subMenuHideHandleChange}
                          >
                            <span className="icon icon-back bs-sub-menu__icon-back"></span>
                          </button>
                          <h3 className="bs-sub-menu__head-title">
                            collections
                          </h3>
                        </div>
                        <div className="bs-sub-menu__cont">
                          <div className="bs-link-list">
                            <h3 className="bs-link-list__title">end use</h3>
                            <ul className="bs-link-list__list-wrap">
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(
                                      `/collections/endUse/curtain`
                                    )
                                  }
                                  className="bs-link-list__link"
                                >
                                  curtains
                                </button>
                              </li>
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(
                                      `/collections/endUse/multipurpose`
                                    )
                                  }
                                  className="bs-link-list__link"
                                >
                                  multipurpose
                                </button>
                              </li>
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(
                                      `/collections/endUse/upholstery`
                                    )
                                  }
                                  className="bs-link-list__link"
                                >
                                  Upholstery
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="bs-link-list">
                            <h3 className="bs-link-list__title">fabric type</h3>
                            <ul className="bs-link-list__list-wrap">
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(
                                      `/collections/fabType/plains`
                                    )
                                  }
                                  className="bs-link-list__link"
                                >
                                  plains
                                </button>
                              </li>
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(
                                      `/collections/fabType/texture`
                                    )
                                  }
                                  className="bs-link-list__link"
                                >
                                  textured
                                </button>
                              </li>
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(
                                      `/collections/fabType/sheers`
                                    )
                                  }
                                  className="bs-link-list__link"
                                >
                                  sheers
                                </button>
                              </li>
                              {/* <li className='bs-link-list__list-item'>
                              <button onClick={() => handleMenuClick(`/collections/fabType/foil`)} className='bs-link-list__link'>foil</button>
                            </li> */}
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(
                                      `/collections/fabType/chenille-and-boucle`
                                    )
                                  }
                                  className="bs-link-list__link"
                                >
                                  chenille and boucle
                                </button>
                              </li>
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(
                                      `/collections/fabType/dimout-and-blackout`
                                    )
                                  }
                                  className="bs-link-list__link"
                                >
                                  dimout and blackout
                                </button>
                              </li>
                              {/* <li className='bs-link-list__list-item'>
                              <button onClick={() => handleMenuClick(`/collections/fabType/embroidery-and-prints`)} className='bs-link-list__link'>embroidery and prints</button>
                            </li> */}
                            </ul>
                          </div>
                          <div className="bs-link-list">
                            <h3 className="bs-link-list__title">category</h3>
                            <ul className="bs-link-list__list-wrap">
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(
                                      `/collections/category/sustainable-yarns`
                                    )
                                  }
                                  className="bs-link-list__link"
                                >
                                  sustainable yarns
                                </button>
                              </li>
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(
                                      `/collections/category/room-darkening`
                                    )
                                  }
                                  className="bs-link-list__link"
                                >
                                  room darkening
                                </button>
                              </li>
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(
                                      `/collections/category/decorative-fabrics`
                                    )
                                  }
                                  className="bs-link-list__link"
                                >
                                  decorative fabrics
                                </button>
                              </li>
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(
                                      `/collections/category/spill-safe`
                                    )
                                  }
                                  className="bs-link-list__link"
                                >
                                  SPILL SAFE
                                </button>
                              </li>
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(`/collections`)
                                  }
                                  className="bs-link-list__link"
                                >
                                  all
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="bs-link-list">
                            <h3 className="bs-link-list__title">collection</h3>
                            <ul className="bs-link-list__list-wrap">
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(
                                      `/collections/trending/trending`
                                    )
                                  }
                                  className="bs-link-list__link"
                                >
                                  trending
                                </button>
                              </li>
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(
                                      `/collections/classic/classic`
                                    )
                                  }
                                  className="bs-link-list__link"
                                >
                                  classic
                                </button>
                              </li>
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    handleMenuClick(`/collections`)
                                  }
                                  className="bs-link-list__link"
                                >
                                  all collections
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>
                    {/* <li className='bs-menu__nav-item bs-menu__new-tag'>
                    <Link to="/shop" onClick={menuActiveHandleChange} className={`bs-menu__nav-link ${location.pathname.includes('our-journey') ? 'bs-menu__nav-link--active' : ''}`}>shop</Link>
                    
                  </li> */}
                    <li
                      className={`bs-menu__nav-item bs-menu__nav-item--shop ${subMenuShow === "shop"
                        ? "bs-menu__nav-item--active"
                        : ""
                        }`}
                    >
                      <div className="bs-menu__new-tag">
                        {window.innerWidth <= 1024 ? (
                          <p
                            onClick={() => {
                              subMenuShowHandleChange("shop");
                              handleMenuClickShop("/products");
                            }}
                            className={`bs-menu__nav-link bs-menu__nav-link--mb ${location.pathname.includes("shop") ||
                              location.pathname.includes(
                                "product-description"
                              ) ||
                              location.pathname.includes("products")
                              ? "bs-menu__nav-link--active"
                              : ""
                              }`}
                          >
                            shop bedding
                            <span className="icon icon-down bs-menu__icon-more"></span>
                          </p>
                        ) : (
                          // <Link to="/collections" onClick={menuActiveHandleChange} className={`bs-menu__nav-link ${location.pathname.includes('collections') || location.pathname.includes('collection-detail') || location.pathname.includes('sku-detail') ? 'bs-menu__nav-link--active' : ''}`}>collections</Link>
                          <button
                            onClick={() => {
                              handleMenuClick("/products");
                              menuActiveHandleChange();
                            }}
                            className={`bs-menu__nav-link ${location.pathname.includes("collections") ||
                              location.pathname.includes("collection-detail") ||
                              location.pathname.includes("sku-detail")
                              ? "bs-menu__nav-link--active"
                              : ""
                              }`}
                          >
                            shop bedding
                          </button>
                        )}
                        {/* <label className="mod-product-tag mod-product-tag--new-2 bs-menu__tag">
                          new
                        </label> */}
                      </div>
                    </li>
                    <li className="bs-menu__nav-item bs-menu__nav-item--sustainability">
                      <Link
                        to="/sustainability"
                        onClick={menuActiveHandleChange}
                        className={`bs-menu__nav-link ${location.pathname.includes("sustainability")
                          ? "bs-menu__nav-link--active"
                          : ""
                          }`}
                      >
                        sustainability
                      </Link>
                    </li>
                    {/* <li className='bs-menu__nav-item bs-menu__nav-item--quality-standards'>
                    <Link to="/quality-standards" onClick={menuActiveHandleChange} className={`bs-menu__nav-link ${location.pathname.includes('quality-standards') ? 'bs-menu__nav-link--active' : ''}`}>quality standards</Link>
                  </li> */}
                    {/* <li className='bs-menu__nav-item bs-menu__nav-item--inspired-living'>
                    <Link to="#" className={`bs-menu__nav-link ${location.pathname.includes('inspired-living') ? 'bs-menu__nav-link--active' : ''}`}>inspired living</Link>
                  </li> */}

                    <li
                      className={`bs-menu__nav-item bs-menu__nav-item--inspired-living ${subMenuShow === "support"
                        ? "bs-menu__nav-item--active"
                        : ""
                        }`}
                    >
                      {window.innerWidth <= 1024 ? (
                        <p
                          onClick={() => subMenuShowHandleChange("support")}
                          className={`bs-menu__nav-link bs-menu__nav-link--mb ${location.pathname.includes("franchise-enquiry")
                            ? "bs-menu__nav-link--active"
                            : ""
                            }`}
                        >
                          support{" "}
                          <span className="icon icon-down bs-menu__icon-more"></span>
                        </p>
                      ) : (
                        <button
                          onClick={() => {
                            // handleMenuClick("/franchise-enquiry");
                            menuActiveHandleChange();
                          }}
                          className={`bs-menu__nav-link ${location.pathname.includes("franchise-enquiry")
                            ? "bs-menu__nav-link--active"
                            : ""
                            }`}
                        >
                          support
                        </button>
                      )}

                      <div className="bs-sub-menu bs-menu__sub-menu">
                        <div className="bs-sub-menu__head">
                          <button
                            className="bs-sub-menu__back-button"
                            onClick={subMenuHideHandleChange}
                          >
                            <span className="icon icon-back bs-sub-menu__icon-back"></span>
                          </button>
                          <h3 className="bs-sub-menu__head-title">
                            support
                          </h3>
                        </div>
                        <div className="bs-sub-menu__cont">
                          <div className="bs-link-list">
                            <ul className="bs-link-list__list-wrap">
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    window.location.href = "https://shop.sansaar.co.in/pages/track-order"
                                  }
                                  className="bs-link-list__link bs-link-list__title"
                                >
                                  Track Orders
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="bs-link-list">
                            <ul className="bs-link-list__list-wrap">
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    window.location.href = "https://shop.sansaar.co.in/pages/return-replacement"
                                  }
                                  className="bs-link-list__link bs-link-list__title"
                                >
                                  Return & Exchange
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="bs-link-list">
                            <ul className="bs-link-list__list-wrap">
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    window.location.href = "https://shop.sansaar.co.in/pages/faq"
                                  }
                                  className="bs-link-list__link bs-link-list__title"
                                >
                                  FAQ's
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="bs-link-list">
                            <ul className="bs-link-list__list-wrap">
                              <li className="bs-link-list__list-item">
                                <button
                                  onClick={() =>
                                    window.location.href = "https://shop.sansaar.co.in/pages/contact"
                                  }
                                  className="bs-link-list__link bs-link-list__title"
                                >
                                  Contact
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li className="bs-menu__nav-item bs-menu__nav-item--where-to-buy">
                      <Link
                        to="/where-to-buy"
                        onClick={menuActiveHandleChange}
                        className={`bs-menu__nav-link ${location.pathname.includes("where-to-buy")
                          ? "bs-menu__nav-link--active"
                          : ""
                          }`}
                      >
                        stores
                      </Link>
                    </li>
                    {/* <li className='bs-menu__nav-item bs-menu__nav-item--contact-us'>
                    <Link to="/franchise-enquiry" onClick={menuActiveHandleChange} className={`bs-menu__nav-link ${location.pathname.includes('contact-us') ? 'bs-menu__nav-link--active' : ''}`}>contact us</Link>
                  </li> */}
                    {/* <li className='bs-menu__nav-item bs-menu__nav-item--contact-us cm-visible-flex-xs'>
                    <Link to="/login" onClick={menuActiveHandleChange} className={`bs-menu__nav-link ${location.pathname.includes('login') ? 'bs-menu__nav-link--active' : ''}`}>login</Link>
                  </li> */}
                  </ul>
                </nav>
              </div>
              <div className="bs-header__sub-menu-wrap">
                {/* <CartDrawer /> */}

                <Link
                  to="/search"
                  className="bs-btn bs-btn__btn-icon bs-header__action"
                >
                  <span className="icon icon-search"></span>
                </Link>

                {/* <SignInModal /> */}

                <button
                  className={`bs-header__menu-action ${menuActive ? "bs-header__menu-action--active" : ""
                    }`}
                  onClick={menuActiveHandleChange}
                >
                  <span className="bs-header__menu-bar"></span>
                  <span className="bs-header__menu-bar"></span>
                  <span className="bs-header__menu-bar"></span>
                </button>
              </div>
            </>
          ) : null}
        </div>
      </header>
    </>
  );
}

export default Header;
